import * as types from "./mutation-type";
import { getAdminUsersQuery } from "./queries.graphql";
import gqlClient from "@/modules/graphql";
import api from '@/modules/api'


const actions = {
  async getAdminUsers({ commit }, variables = {}) {
    try {
      commit(types.GET_ADMIN_USERS_BEGIN);
      const {
        data: {
          data   
        }
      } = await gqlClient.query({
        query     : getAdminUsersQuery,
        variables : {
          ...variables,
          isSplusTheme : process.env.VUE_APP_THEME === 'schedulingplus'
        }
      });
      commit(types.GET_ADMIN_USERS_SUCCESS, data.system.users);
    } catch (e) {
      commit(types.GET_ADMIN_USERS_ERROR, e);
    }
  },

  async sendResetPasswordLink({ commit }, user ) {
    try {
      commit(types.SEND_RESET_PASSWORD_LINK_BEGIN);
      
      await api.user.sendResetPasswordLink(user)

      commit(types.SEND_RESET_PASSWORD_LINK_SUCCESS);
    } catch (e) {
      commit(types.SEND_RESET_PASSWORD_LINK_ERROR, e);
    }
  },

  async deleteAdminUser({ commit }, id) {
    try {
      commit(types.DELETE_USER_BEGIN);
      await api.user.deleteUser(id);

      commit(types.DELETE_USER_SUCCESS, id);
    } catch (e) {
      commit(types.DELETE_USER_ERROR, e);
    }
  },
  async assignOrRevokeAdminRights({ commit }, data) {
    const userId = data.userId
    try {
      commit(types.ASSIGN_REVOKE_ADMIN_RIGHTS_BEGIN, userId)

      await api.admin.assignOrRevokeAdminRights(data);
      
      commit(types.ASSIGN_REVOKE_ADMIN_RIGHTS_SUCCESS, data)
    } catch (error) {
      commit(types.ASSIGN_REVOKE_ADMIN_RIGHTS_ERROR, { error, userId })
    }
  }
};

export default actions;
